import classNames from "classnames";
import React from "react";
import * as Ons from "react-onsenui";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { CALENDAR_SVG } from "../../../utils/svgs";
import { FILTER_ICON, MAP_MARKER_ICON, SORT_ICON } from "../../../utils/svgs_new";
import { AppIcon } from "../../Generic/AppIcon";
import { VisitSort } from "../MainTypes";

interface Props {
  sort: VisitSort;
  isMapOpen: boolean;
  isSortActionOpen: boolean;
  onClickMap: () => void;
  onClickSort: () => void;
  onClickFilter: () => void;
  onChooseSort: (sort: VisitSort | null) => void;
}

const VisitsOptions = (props: Props) => {
  const handleClickSort = (value: VisitSort) => {
    props.onChooseSort(value);
  };

  return (
    <div className="VisitsOptions">
      <div onClick={props.onClickMap} className={classNames({ active: props.isMapOpen })}>
        {props.isMapOpen ? (
          <>
            <AppIcon icon={CALENDAR_SVG} size={12} />
            <span>{translate(STRINGS.VISITS)}</span>
          </>
        ) : (
          <>
            <AppIcon icon={MAP_MARKER_ICON} size={12} />
            <span>{translate(STRINGS.MAP)}</span>
          </>
        )}
      </div>
      <div onClick={props.onClickSort} className={classNames({ active: props.isSortActionOpen })}>
        <AppIcon icon={SORT_ICON} size={12} />
        <span>{translate(STRINGS.SORT)}</span>
      </div>
      <div onClick={props.onClickFilter}>
        <AppIcon icon={FILTER_ICON} size={10} />
        <span>{translate(STRINGS.FILTERS)}</span>
      </div>
      <Ons.ActionSheet isOpen={props.isSortActionOpen} onCancel={() => props.onChooseSort(null)}>
        <Ons.ActionSheetButton onClick={() => handleClickSort("POSTED_DATE")}>
          {translate(STRINGS.POSTED_DATE)}
        </Ons.ActionSheetButton>

        <Ons.ActionSheetButton onClick={() => handleClickSort("START_DATE")}>
          {translate(STRINGS.START_DATE)}
        </Ons.ActionSheetButton>

        <Ons.ActionSheetButton onClick={() => handleClickSort("DISTANCE")}>
          {translate(STRINGS.DISTANCE)}
        </Ons.ActionSheetButton>

        <Ons.ActionSheetButton onClick={() => handleClickSort("PRICE")}>
          {translate(STRINGS.PRICE)}
        </Ons.ActionSheetButton>

        <Ons.ActionSheetButton onClick={() => props.onChooseSort(null)}>
          {translate(STRINGS.CANCEL)}
        </Ons.ActionSheetButton>
      </Ons.ActionSheet>
    </div>
  );
};

export default VisitsOptions;
